module.exports = __webpack_public_path__ + "static/media/CaviarDreams_BoldItalic.825e49e4.ttf";